/**
 * The salary-breakup queries (People → Pay yearly CTC line, Me → Pay
 * "My salary" card) and the one helper every mutation that changes a
 * person's salary inputs calls.
 *
 * Review 2026-10: after HR edited Basic / HRA / Special in the
 * edit-employee form, the Compensation card showed the new monthly gross
 * next to a Yearly CTC worked out from the old salary for up to 5 minutes
 * (the query client's staleTime), because the save never flushed this
 * query. Pinned by lib/salary-queries.test.ts.
 *
 * Plain .ts with type-only imports so the node unit tests can load it.
 */

import type { InvalidatingClient } from "./payroll-setup-queries";

/** react-query key of GET /api/v1/payroll/me/salary. */
export const MY_SALARY_QUERY_KEY = ["payroll", "me", "salary"] as const;

/** react-query key of one employee's salary breakup (People → Pay). */
export function employeeSalaryQueryKey(id: number) {
  return ["payroll", "employee-salary", id] as const;
}

/**
 * Refetch the person's salary breakup. My salary is flushed too: the
 * edited person may be the caller, and the GET only refetches while the
 * card is on screen (otherwise the entry is just marked stale).
 */
export function invalidateSalaryBreakup(qc: InvalidatingClient, employeeId: number): void {
  void qc.invalidateQueries({ queryKey: employeeSalaryQueryKey(employeeId) });
  void qc.invalidateQueries({ queryKey: MY_SALARY_QUERY_KEY });
}
